"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _css = require("@emotion/css");
var _react = require("react");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = () => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const ccImageEditorStyle = (0, _react.useMemo)(() => {
    const deviceProps = () => {
      if (isMobileView) {
        return {
          height: pxToRem(316),
          width: '100%',
          overflow: 'hidden',
          borderRadius: pxToRem(8)
        };
      }
      return {
        height: pxToRem(232),
        width: pxToRem(424)
      };
    };
    const zoomBtnProps = () => {
      return {
        content: '""',
        position: 'absolute',
        width: '100%',
        height: pxToRem(3),
        background: 'currentColor',
        top: '50%',
        left: '50%',
        transformOrigin: 'center center'
      };
    };
    const zoomProps = () => {
      return {
        position: 'absolute',
        top: '50%',
        transform: 'translate(0, -50%)',
        width: pxToRem(20),
        height: pxToRem(48),
        color: themeColors?.primary.main,
        cursor: 'pointer',
        '&::before': {
          ...zoomBtnProps(),
          transform: 'translate(-50%, -50%)'
        }
      };
    };
    const ccImageEditor = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    });
    const ccImageEditorCrop = (0, _css.css)({
      position: 'relative',
      ...deviceProps()
    });
    const ccImageEditorSlider = (0, _css.css)({
      position: 'relative',
      width: '100%',
      textAlign: 'center'
    });
    const ccImageEditorZoomIn = (0, _css.css)({
      ...zoomProps(),
      right: 0,
      '&::after': {
        ...zoomBtnProps(),
        transform: 'translate(-50%, -50%) rotate(90deg)'
      }
    });
    const ccImageEditorZoomOut = (0, _css.css)({
      ...zoomProps(),
      left: 0
    });
    return {
      ccImageEditor,
      ccImageEditorCrop,
      ccImageEditorSlider,
      ccImageEditorZoomIn,
      ccImageEditorZoomOut
    };
  }, [isMobileView, pxToRem, themeColors?.primary.main]);
  return {
    'cc-ImageEditor': ccImageEditorStyle.ccImageEditor,
    'cc-ImageEditor__crop': ccImageEditorStyle.ccImageEditorCrop,
    'cc-ImageEditor__slider': ccImageEditorStyle.ccImageEditorSlider,
    'cc-ImageEditor__zoom-in': ccImageEditorStyle.ccImageEditorZoomIn,
    'cc-ImageEditor__zoom-out': ccImageEditorStyle.ccImageEditorZoomOut
  };
};
exports.useStyles = useStyles;